<template>
	<div>
    <p>相机</p>
    <input type="file" id='image' accept="image/*" capture='camera'>
    <p>视频</p>
    <input type="file" id='video' accept="video/*" capture='camcorder'>
    <button class="video" @click="videox">录制视频</button>
	</div>
</template>
<script>
import $ from 'jquery';
export default {
  data() {
    return {
    };
  },
//
  methods: {
    videox () {
      alert('videox')
    },
  },
//
  mounted(){
    var file = document.querySelector('input');
    if (getIos()) {
      file.removeAttribute("capture");
    }
    function getIos() {
      var ua=navigator.userAgent.toLowerCase();
      if (ua.match(/iPhone\sOS/i) == "iphone os") {
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.video{
  margin-top: 15px;
  width: 100%;
  height: 50px;
  background-color: #eee;
}

/*tu*/
.cross{
	position: relative;
	bottom: 63px;
	left: 30px;
	width: 33px;
	height: 33px;
	background:url(../../img/add.png);
	background-size:100% 100%;
	background-repeat: no-repeat;
	display: block;
	z-index: 0;
}
.cha{
	float: left;
	width: 100px;
	height: 100px;
	overflow: hidden;
	text-align: center;
}
.ssr{
	width: auto;
}
.load {
	float: left;
	margin: 5px;
	width: 95px;
	height: 95px;
	background-color: #cccccc;
	input {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		z-index: 666;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/video/video.vue